<template>
    <div class="container" v-if="!qrcodeObject?.inactiveLandingPageUrl?.length">
        <h1>Game Over...</h1>
        <div class="content">
            {{ $t("inactive.landingPageText") }}
        </div>
    </div>
    <iframe
        class="iframe"
        v-else
        width="100%"
        height="100%"
        :src="qrcodeObject?.inactiveLandingPageUrl"
    />
</template>
<script lang="ts">
import { State } from "@/store";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
    computed: {
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject
        })
    }
});
</script>
<style scoped>
.container,
.iframe {
    background-color: var(--black);
    color: var(--white);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

h1 {
    font-size: 2.5em;
}

.content {
    padding: 15px 10px;
    border: 1px solid var(--white);
    border-radius: 3px;
    font-weight: bold;
    width: 75%;
    max-width: 300px;
    font-size: 1.4em;
}

.iframe {
    border: 0;
}
</style>
